import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class Icon extends PureComponent {
  render() {
    const { icon, extraClassNames } = this.props;
    return (
      <svg focusable="false" className={`c-icon ${extraClassNames}`} aria-hidden="true">
        <use xlinkHref={`/assets/icon_sprite.svg#${icon}`} />
      </svg>
    );
  }
}

Icon.propTypes = {
  icon: PropTypes.string.isRequired,
  extraClassNames: PropTypes.string,
};

Icon.defaultProps = {
  extraClassNames: '',
};

export default Icon;
